import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * The app's caution colours: the `warning` theme token (tailwind.config.ts,
 * channels in src/index.css: Tailwind's amber-500 / amber-700, added 2026-10-30
 * as the theme groundwork), worn by every amber caution surface as this one
 * idiom (SIMP-39). The `dark:` shade stays literal: the app has no theme
 * toggle, and no token carries amber-400. themeTokens.test.ts fails on a new
 * palette literal and on a `*-warning` class that does not resolve.
 */
export const WARNING_TONE =
  "border-warning/40 bg-warning/10 text-warning-foreground dark:text-amber-400"

/** A small caution note under a field or in a dialog. Pass `role` ("alert" for
 *  something that just went wrong, "note" for standing advice) and any layout
 *  (`flex items-start gap-…` beside an icon) through. */
const WarningNote = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("rounded-md border px-3 py-2 text-xs", WARNING_TONE, className)}
    {...props}
  />
))
WarningNote.displayName = "WarningNote"

export { WarningNote }
